var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field-content" }, [
    _c("div", { staticClass: "section-field input-field pb-0 border-0" }, [
      _c(
        "div",
        { staticClass: "configuration-section" },
        [
          _c("h4", { staticClass: "configuration-section-title" }, [
            _vm._v("General")
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            { class: { "error-input": _vm.$v.dataSetup.title.$error } },
            [
              _c("label", [_vm._v(" Title ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.dataSetup.title.$error,
                  placeholder: "Type title for this component"
                },
                model: {
                  value: _vm.dataSetup.title,
                  callback: function($$v) {
                    _vm.$set(_vm.dataSetup, "title", $$v)
                  },
                  expression: "dataSetup.title"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f24609d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f24609d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/forms/jComponentForm.vue
// module id = null
// module chunks = 